/**
 * Mixin can be included in components which needs a property to choose
 * between old (none) and new design system.
 *
 * @mixin
 */
export default {
  props: {
    /**
     * Set the design system.
     */
    design: {
      type: String,
      default: '',
      validator(value) {
        return ['', 'design2'].includes(value);
      },
    },

    /**
     * Set the size according to the design system.
     */
    designSize: {
      type: String,
      default: 'medium',
      validator(value) {
        return ['large', 'medium', 'small'].includes(value);
      },
    },
  },

  computed: {
    designModifiers() {
      const { design, designSize } = this;

      return {
        design,
        designSize: (design && designSize) || null,
      };
    },
  },
};
